import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

    connect() {
        this.multiple = this.element.dataset.multiple;
        this.text = this.element.dataset.defaulttext;
        this.link = this.element.dataset.clickredirect;
        this.submit = this.element.dataset.submit;

        // for gtranslate
        this.showflags = this.element.dataset.showflags;

        // for currency-switcher
        this.showcurrency = this.element.dataset.showcurrency;

        const SELECT = this.element.querySelector('select');
        const WRAPPER = Object.assign(document.createElement('div'),{ classList: 'js-select' });
        SELECT.parentNode.insertBefore(WRAPPER, SELECT);
        const DROPDOWN = Object.assign(document.createElement('ul'),{ classList: 'select-dropdown' });
        const SELECTION = Object.assign(document.createElement('div'),{ classList: 'selected' });
        WRAPPER.appendChild(SELECT);
        WRAPPER.appendChild(SELECTION);
        WRAPPER.appendChild(DROPDOWN);

        let html = '';
        for (const option of SELECT.options) {
            const selectedAttr = option.selected ? `data-selected="true"` : '';
            const name = option.innerText.replace(/\((.+?)\)/g, '');
            if (this.multiple) {
                html += `<li data-value="${option.value}" data-name="${name}" ${selectedAttr}><label><input type="checkbox" ${option.selected ? 'checked' : ''}/> ${option.innerText}</label></li>`;
            } else {
                if (this.showflags) {
                    let lang = option.value;
                    if (lang) {
                        lang = lang.split('|')[1];
                        let langcode = lang;
                        if (lang === 'en') {
                            langcode = 'en-us';
                        }
                        html += `<li data-value="${option.value}" data-name="${lang}" ${selectedAttr}><img src="https://cdn.gtranslate.net/flags/svg/${langcode}.svg" alt=""> ${lang}</li>`;
                    } else {
                        lang = option.innerText.replace(/\((.+?)\)/g, '');
                        html += `<li data-value="${option.value}" data-name="${lang}" ${selectedAttr}>${lang}</li>`;
                    }
                } else if (this.showcurrency) {
                    let currency = name.split(' ')[0];
                    if (currency === "USD") {
                        currency = '$';
                    } else if (currency === "EUR") {
                        currency = '€';
                    } else if (currency === "GBP") {
                        currency = '£';
                    }
                    html += `<li data-value="${option.value}" data-name="${currency}" ${selectedAttr}>${currency}</li>`;
                } else {
                    html += `<li data-value="${option.value}" data-name="${name}" ${selectedAttr}>${option.innerText}</li>`;
                }
            }
        }
        DROPDOWN.insertAdjacentHTML('afterbegin', html);

        document.addEventListener('click', (e) => {
            if ( !WRAPPER.contains(e.target) ) {
                DROPDOWN.style.display = 'none';
                WRAPPER.classList.remove('select-open');
            }
        });

        let selectedValues = [];
        let selectedText = [];
        for (const option of SELECT.options) {
            if (option.selected) {
                if (this.showflags) {
                    let lang = option.value.split('|')[1];
                    let langcode = lang;
                    if (lang === 'en') {
                        langcode = 'en-us';
                    }
                    selectedText.push(`<img src="https://cdn.gtranslate.net/flags/svg/${langcode}.svg" alt="">` + lang);
                    selectedValues.push(lang);
                } else if (this.showcurrency) {
                    let currency = option.text.split(' ')[0];
                    if (currency === "USD") {
                        currency = '$';
                    } else if (currency === "EUR") {
                        currency = '€';
                    } else if (currency === "GBP") {
                        currency = '£';
                    }
                    selectedText.push(currency);
                    selectedValues.push(option.value.replace(/\((.+?)\)/g, ""));
                } else {
                    selectedText.push(option.text.replace(/\((.+?)\)/g, ""));
                    selectedValues.push(option.value.replace(/\((.+?)\)/g, ""));
                }
            }
        }
        SELECTION.innerHTML = selectedText.length > 0 ? selectedText.join(', ') : this.text;
        SELECTION.setAttribute('data-selected-value', selectedValues.length > 0 ? selectedValues.join(', ') : '');
        SELECTION.addEventListener('click', () => {
            if (WRAPPER.classList.contains('select-open')) {
                DROPDOWN.style.display = 'none';
                WRAPPER.classList.remove('select-open');
            } else {
                DROPDOWN.style.display = 'block';
                WRAPPER.classList.add('select-open');
            }
        });

        if (this.multiple) {
            for (const span of SELECTION.querySelectorAll('span')) {
                span.addEventListener('click', () => {
                    this.element.querySelector(`input[name="${span.dataset.value}"]`).checked = false;
                    update();
                });
            }
        }

        for (const li of DROPDOWN.querySelectorAll('li')) {
            li.addEventListener('click', () => {
                if (this.multiple) {
                    update();
                } else {
                    SELECT.value = li.dataset.value;
                    SELECTION.setAttribute('data-selected-value', li.dataset.value);
                    SELECTION.innerHTML = li.dataset.name;
                    if (this.link) {
                        location.href = li.dataset.value;
                    }
                }

                SELECT.dispatchEvent(new Event('change'));
                DROPDOWN.style.display = 'none';
                WRAPPER.classList.remove('select-open');

                if (this.submit) {
                    let form = this.element.closest('form');
                    if (form) {
                        form.submit();
                    } else {
                        form = this.element.querySelector('form');
                        if (form) {
                            form.submit();
                        }
                    }
                }
            });
        }

        if (this.multiple) {
            SELECT.addEventListener('change', () => {
                sync();
            });
        }

        const sync = () => {
            for (const option of SELECT.options) {
                for (const li of DROPDOWN.querySelectorAll('li')) {
                    const checkbox = li.querySelector("input[type='checkbox']");
                    if (option.value === li.getAttribute('data-value')) {
                        checkbox.checked = !!option.selected;
                    }
                }
            }
            update();
        }

        const update = () => {
            let names = [],
                values = [];

            for (const li of DROPDOWN.querySelectorAll('li')) {
                const checkbox = li.querySelector("input[type='checkbox']")
                if (checkbox && checkbox.checked) {
                    names.push(li.dataset.name);
                    values.push(li.dataset.value);
                }
            }

            for (const option of SELECT.options) {
                if (option.value) {
                    option.selected = values.indexOf(option.value) >= 0;
                }
            }

            if (names && names.length > 0) {
                SELECTION.innerHTML = names.join(', ');
                SELECTION.setAttribute('data-multiple-selected', '');
                SELECTION.style.setProperty('--select-amount', names.length);
            } else {
                SELECTION.innerHTML = this.text;
                SELECTION.removeAttribute('data-multiple-selected');
                SELECTION.style.removeProperty('--select-amount');
            }
        }
    }
}